module.exports = __webpack_public_path__ + "static/media/instagram-round.a1d1077a.svg";